import React, { MouseEventHandler } from 'react';

interface GameContainerProps {
    count: number,
    fillState: Array<string>,
    handleClick: MouseEventHandler<HTMLDivElement> 
}


export default function GameContainers ({ count, fillState, handleClick } : GameContainerProps) {

    var tokens = Array.from(fillState);
    tokens.length = count * 4;
    tokens = tokens.fill("", fillState.length, count * 4);
    var idx = 0;
    
    return (
        <>
            <h3>Game Board</h3>
            {Array.from({ length: count }).map((value, index) => (
                <div className="gameTokenContainer" key={index} onClick={handleClick}>
                    {tokens.slice(index * 4, (index + 1) * 4).reverse().map((color) => (
                            <svg xmlns="http://www.w3.org/2000/svg" height="25" width="25" key={idx++}>
                                <circle cx="12" cy="12" r="12" fill={(color === "" ? "transparent" : color)} />
                            </svg>
                    ))}
                    <div className="gameTokenContainerId" key={index}>{index}</div>
                </div>
            ))}
        </>
    );    
}

